import { MARKET_SCENARIOS } from '@arya/market/mock';
import { MARKET_PROJECT_SCENARIOS } from '@arya/market/project/mock';
import type { DevScenario } from '@arya/shared/domain';

import { DEV_SCENARIO_ENTRIES, LAST_DEV_SCENARIO_ENTRIES } from './dev-scenario-entries';

export const DEV_SCENARIOS: readonly DevScenario[] = [
  ...MARKET_SCENARIOS,
  ...MARKET_PROJECT_SCENARIOS,
  ...[...DEV_SCENARIO_ENTRIES, ...LAST_DEV_SCENARIO_ENTRIES].map(({ scenario }) => scenario),
];
